import React from 'react';

import { Icon } from '../Icon';

import {
  ICON_SET_FONTAWESOME,
  FONT_AWESOME_SOLID,
} from 'lane-shared/helpers/constants/icons';

import styles from './SortIcon.scss';
import { SortDirectionEnum } from 'constants-activate';

type SortIconProps = {
  direction?: SortDirectionEnum;
};

export const SortIcon = ({ direction }: SortIconProps) => {
  if (direction === SortDirectionEnum.Asc) {
    return (
      <Icon
        name="sort-down"
        set={ICON_SET_FONTAWESOME}
        className={styles.Icon}
        type={FONT_AWESOME_SOLID}
        testId="sort-icon"
      />
    );
  }

  if (direction === SortDirectionEnum.Desc) {
    return (
      <Icon
        name="sort-up"
        className={styles.Icon}
        set={ICON_SET_FONTAWESOME}
        type={FONT_AWESOME_SOLID}
        testId="sort-icon"
      />
    );
  }

  return (
    <Icon
      name="sort"
      className={styles.Icon}
      set={ICON_SET_FONTAWESOME}
      type={FONT_AWESOME_SOLID}
      testId="sort-icon"
    />
  );
};
